import { render } from "./MyProfile.vue?vue&type=template&id=2301ff16"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"

import "./MyProfile.vue?vue&type=style&index=0&id=2301ff16&lang=less"
script.render = render

export default script